<template>
  <image-list :list="list" />
</template>

<script>
import ImageList from "@/components/ImageList.vue";

export default {
  name: "bygninger",
  components: {
    ImageList
  },
  data() {
    return {
      list: [
        {
          id: 1,
          type: "Left2MiddleRight",
          leftImage: "/images/bygninger/1/left.jpg",
          leftImageHeight: 420,
          middleTopImage: "/images/bygninger/1/middle-top.jpg",
          middleTopImageHeight: 106,
          middleBottomImage: "/images/bygninger/1/middle-bottom.jpg",
          middleBottomImageHeight: 240,
          rightImage: "/images/bygninger/1/right.jpg",
          rightImageHeight: 420,
          leftText:
            "AUDITORIEBYGNING OG UDSTILLINGSBYGNING   ARKITEKTSKOLEN   NØRREPORT AARHUS   1997",
          rightText: ""
        },
        {
          id: 2,
          type: "Left2Right",
          leftImage: "/images/bygninger/2/left.jpg",
          leftImageHeight: 450,
          rightTopImage: "/images/bygninger/2/right-top.jpg",
          rightTopImageHeight: 163,
          rightBottomImage: "/images/bygninger/2/right-bottom.png",
          rightBottomImageHeight: 270,
          leftText:
            "AUDITORIEBYGNING OG UDSTILLINGSBYGNING   ARKITEKTSKOLEN   NØRREPORT AARHUS   1997",
          rightText: ""
        },
        {
          id: 3,
          type: "LeftRight",
          leftImage: "/images/bygninger/3/left.jpg",
          leftImageHeight: 450,
          rightImage: "/images/bygninger/3/right.jpg",
          rightImageHeight: 450,
          leftText: "VÅBENHUS   SKRYDSTRUP KIRKE  2000",
          rightText:
            "AGNUS DEI   BÆNK   DØRGREB    BILLEDHUGGER   JETTE VOHLERT"
        },
        {
          id: 4,
          type: "Left2Right",
          leftImage: "/images/bygninger/4/left.jpg",
          leftImageHeight: 450,
          rightTopImage: "/images/bygninger/4/right-top.jpg",
          rightTopImageHeight: 285,
          rightBottomImage: "/images/bygninger/4/right-bottom.jpg",
          rightBottomImageHeight: 150,
          leftText: "VÅBENHUS  SKRYDSTRUP KIRKE 2000",
          rightText: "AGNUS DEI  BÆNK OG DØRGREB  BILLEDHUGGER JETTE VOHLERT"
        },
        {
          id: 5,
          type: "2LeftRight",
          leftTopImage: "/images/bygninger/5/left-top.jpg",
          leftTopImageHeight: 217,
          leftBottomImage: "/images/bygninger/5/left-bottom.jpg",
          leftBottomImageHeight: 217,
          rightImage: "/images/bygninger/5/right.jpg",
          rightImageHeight: 450,
          leftText: "MUSIKHUSET   AARHUS  1977 - 82",
          rightText: ""
        },
        {
          id: 6,
          type: "LeftRight",
          leftImage: "/images/bygninger/6/left.jpg",
          leftImageHeight: 390,
          rightImage: "/images/bygninger/6/right.jpg",
          rightImageHeight: 390,
          leftText: "MUSIKHUSET AARHUS 1977 - 82",
          rightText: ""
        },
        {
          id: 7,
          type: "LeftRight",
          leftImage: "/images/bygninger/7/left.jpg",
          leftImageHeight: 450,
          rightImage: "/images/bygninger/7/right.jpg",
          rightImageHeight: 450,
          leftText: "MUSIKHUSET   AARHUS  1977 - 82",
          rightText: ""
        },
        {
          id: 8,
          type: "LeftRight",
          leftImage: "/images/bygninger/8/left.jpg",
          leftImageHeight: 270,
          rightImage: "/images/bygninger/8/right.jpg",
          rightImageHeight: 390,
          leftText:
            "VESTIBULE  RECEPTION    DE DANSKE SPRITFABRIKKER A/S    AMAGER  1987",
          rightText: ""
        },
        {
          id: 9,
          type: "LeftRight",
          leftImage: "/images/bygninger/9/left.jpg",
          leftImageHeight: 450,
          rightImage: "/images/bygninger/9/right.jpg",
          rightImageHeight: 450,
          leftText:
            "VESTIBULE  RECEPTION    DE DANSKE SPRITFABRIKKER A/S    AMAGER  1987",
          rightText: ""
        },
        {
          id: 10,
          type: "Center",
          centerImage: "/images/bygninger/10/center.jpg",
          centerImageHeight: 450,
          leftText: "BISPEBOLIG DALGAS AVENUE  AARHUS  1994 - 96",
          rightText: ""
        },
        {
          id: 11,
          type: "2LeftMiddle2Right",
          leftTopImage: "/images/bygninger/11/left-top.jpg",
          leftTopImageHeight: 202,
          leftBottomImage: "/images/bygninger/11/left-bottom.jpg",
          leftBottomImageHeight: 210,
          middleImage: "/images/bygninger/11/middle-center.jpg",
          middleImageHeight: 150,
          rightTopImage: "/images/bygninger/11/right-top.jpg",
          rightTopImageHeight: 200,
          rightBottomImage: "/images/bygninger/11/right-bottom.jpg",
          rightBottomImageHeight: 212,
          leftText:
            "BISPEBOLIG  DALGAS  AVENUE  AARHUS   OPRINDELIGT  FORSLAG  1994",
          rightText: ""
        },
        {
          id: 12,
          type: "2LeftRight",
          leftTopImage: "/images/bygninger/12/left-top.jpg",
          leftTopImageHeight: 225,
          leftBottomImage: "/images/bygninger/12/left-bottom.jpg",
          leftBottomImageHeight: 170,
          rightImage: "/images/bygninger/12/right.jpg",
          rightImageHeight: 390,
          leftText: " STENSBALLEGÅRD  GOLFKLUB 2009",
          rightText: ""
        },
        {
          id: 120,
          type: "Center",
          centerImage: "/images/bygninger/120/1-center.jpg",
          centerImageHeight: 450,
          leftText: "NY HERREGAARD NORDJYLLAND 2018-2021",
          rightText: ""
        },
        {
          id: 121,
          type: "Center",
          centerImage: "/images/bygninger/120/2-center.jpg",
          centerImageHeight: 450,
          leftText: "NY HERREGAARD NORDJYLLAND 2018-2021",
          rightText: ""
        },
        {
          id: 122,
          type: "Center",
          centerImage: "/images/bygninger/120/3-center.jpg",
          centerImageHeight: 450,
          leftText: "NY HERREGAARD NORDJYLLAND 2018-2021",
          rightText: ""
        },
        {
          id: 13,
          type: "Left2Right",
          leftImage: "/images/bygninger/13/left.jpg",
          leftImageHeight: 430,
          rightTopImage: "/images/bygninger/13/right-top.jpg",
          rightTopImageHeight: 247,
          rightBottomImage: "/images/bygninger/13/right-bottom.jpg",
          rightBottomImageHeight: 175,
          leftText:
            "GREENLAND PASSAGE   GREENLAND DOCKS   RIVER THAMES   LONDON  1985 - 1992",
          rightText: ""
        },
        {
          id: 14,
          type: "LeftMiddleRight",
          leftImage: "/images/bygninger/14/left.jpg",
          leftImageHeight: 400,
          middleImage: "/images/bygninger/14/middle.jpg",
          middleImageHeight: 200,
          rightImage: "/images/bygninger/14/right.jpg",
          rightImageHeight: 400,
          leftText:
            "GREENLAND PASSAGE  GREENLAND DOCKS   RIVER THAMES   LONDON 1985 - 1992",
          rightText: ""
        },
        {
          id: 15,
          type: "3LeftRight",
          leftTopImage: "/images/bygninger/15/left-top.jpg",
          leftTopImageHeight: 300,
          leftBottomLeftImage: "/images/bygninger/15/left-bottom-left.jpg",
          leftBottomLeftImageHeight: 130,
          leftBottomRightImage: "/images/bygninger/15/left-bottom-right.jpg",
          leftBottomRightImageHeight: 130,
          rightImage: "/images/bygninger/15/right.jpg",
          rightImageHeight: 450,
          leftText: "KREDITFORENINGEN DANMARK   ÅBOULEVARDEN   AARHUS  1984",
          rightText: ""
        },
        {
          id: 16,
          type: "LeftRight",
          leftImage: "/images/bygninger/16/left.jpg",
          leftImageHeight: 310,
          rightImage: "/images/bygninger/16/right.jpg",
          rightImageHeight: 310,
          leftText: "KREDITFORENINGEN DANMARK   ÅBOULEVARDEN   AARHUS  1984",
          rightText: ""
        },
        {
          id: 17,
          type: "LeftRight",
          leftImage: "/images/bygninger/17/left.jpg",
          leftImageHeight: 340,
          rightImage: "/images/bygninger/17/right.jpg",
          rightImageHeight: 340,
          leftText: "BILLEDHUGGERATELIER   MARSELISVEJ   AARHUS  1997",
          rightText: ""
        },
        {
          id: 18,
          type: "Left2Right",
          leftImage: "/images/bygninger/18/left.jpg",
          leftImageHeight: 440,
          rightTopImage: "/images/bygninger/18/right-top.jpg",
          rightTopImageHeight: 210,
          rightBottomImage: "/images/bygninger/18/right-bottom.jpg",
          rightBottomImageHeight: 210,
          leftText: "KALØ GODS   NY MØDE- OG KANTINEBYGNING  1996 - 2016",
          rightText: ""
        },
        {
          id: 19,
          type: "LeftRight",
          leftImage: "/images/bygninger/19/left.jpg",
          leftImageHeight: 400,
          rightImage: "/images/bygninger/19/right.jpg",
          rightImageHeight: 400,
          leftText: "KALØ GODS     LABORATORIEBYGNING  2007",
          rightText: ""
        },
        {
          id: 20,
          type: "LeftMiddleRight",
          leftImage: "/images/bygninger/20/left.jpg",
          leftImageHeight: 450,
          middleImage: "/images/bygninger/20/middle.jpg",
          middleImageHeight: 450,
          rightImage: "/images/bygninger/20/right.jpg",
          rightImageHeight: 450,
          leftText: "LANDSUDSTILLINGEN   AARHUS    75 ÅRS  JUBILÆUM",
          centerText: "SØJLE  OG TEMPELFRONT",
          rightText: "KUNST JAN NORMAN OG HANS KRULL"
        },
        {
          id: 21,
          type: "LeftRight",
          leftImage: "/images/bygninger/21/left.jpg",
          leftImageHeight: 350,
          rightImage: "/images/bygninger/21/right.jpg",
          rightImageHeight: 350,
          leftText:
            "LANDSUDSTILLINGEN  I  AARHUS  75 ÅRS   JUBILÆUM  1984  UDSTILLING AFHOLDT I RÅDHUSHALLEN",
          rightText: ""
        }
      ]
    };
  }
};
</script>
